// agents/cygaar.js
import { buildCygaarMessage } from '../services/ai.js';

export function handleCygaarMessage() {
  window.logToConsole("👑 TIP OF THE DAY");
  buildCygaarMessage().then(msg => {
    window.showTypingModal(msg);
    window.logToConsole(`👑 ROYAL MESSAGE:\n${msg}`);
  });
}